export const truncateToTwo = (num) =>
  Number(
    ((Number(num) * 100) / 100)
      .toString()
      .match(/^-?\d+(?:\.\d{0,2})?/)
      ?.at(0)
  );
